import React from "react";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
export const PermissionItem = (props) => {
  return (
    <div>
      {props.permval ? (
        <CheckCircleOutlined style={{ color: "#52c41a" }} />
      ) : (
        <CloseCircleOutlined style={{ color: "#ff4d4f" }} />
      )}
    </div>
  );
};

